// src/utils/auth.js
const STORAGE_KEY = "lefy_auth"; // hanya 1 key dipakai di seluruh app

export function getAuthRaw() {
  try {
    const s = localStorage.getItem(STORAGE_KEY);
    return s ? JSON.parse(s) : null;
  } catch (e) {
    console.error("getAuthRaw parse error", e);
    return null;
  }
}

export function setAuth({ jwt, user }) {
  const payload = {
    jwt: jwt || null,
    user: user || null,
    createdAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function clearAuth() {
  localStorage.removeItem(STORAGE_KEY);
  // jika Anda masih memiliki legacy keys, juga hapus di sini
  localStorage.removeItem("jwt");
  localStorage.removeItem("username");
  localStorage.removeItem("email");
  localStorage.removeItem("avatar");
}

export function getUser() {
  const auth = getAuthRaw();
  return auth?.user ?? null;
}

export function getJwt() {
  const auth = getAuthRaw();
  return auth?.jwt ?? null;
}

export function isLogged() {
  const jwt = getJwt();
  if (!jwt) return false;

  if (isJwtExpired(jwt)) {
    console.warn("JWT expired → clearing auth");
    clearAuth();
    return false;
  }

  return true;
}

// decode base64url
function base64UrlDecode(str) {
  try {
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

export function isJwtExpired(jwt) {
  if (!jwt) return true;
  const parts = jwt.split('.');
  if (parts.length !== 3) return true;

  const payload = base64UrlDecode(parts[1]);
  if (!payload || !payload.exp) return true;

  // exp dalam detik → Date.now() ms
  return payload.exp * 1000 < Date.now();
}
